import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import PublicNav from "../components/PublicNav";
import PublicFooter from "../components/PublicFooter";
import SeoHead from "../components/SeoHead";

/**
 * NotFound — public 404 page. Kept minimal, respects Design System.
 */
export default function NotFound() {
  return (
    <div className="afr-root" data-testid="afr-notfound-root">
      <SeoHead
        title="Page introuvable"
        description="Cette page n'existe pas ou a été déplacée."
        noIndex
      />
      <PublicNav />
      <section className="afr-section" style={{ textAlign: "center", padding: "6rem 2rem" }}>
        <span className="afr-eyebrow">Erreur 404</span>
        <h1 className="afr-hero__title" style={{ fontSize: "clamp(2.4rem, 6vw, 4rem)", margin: "1rem auto 1.4rem", maxWidth: "22ch" }}>
          Cette page n'existe pas.
        </h1>
        <p className="afr-hero__lead" style={{ margin: "0 auto 2rem" }}>
          Le lien que vous avez suivi est peut-être obsolète ou la page a été déplacée.
          Retournez à l'écosystème AFRICTAL pour poursuivre votre exploration.
        </p>
        <div className="afr-flex-row" style={{ justifyContent: "center" }}>
          <Link to="/" className="afr-btn afr-btn--primary afr-btn--lg" data-testid="notfound-btn-home">
            <Compass size={16} /> Retour à l'accueil
          </Link>
          <Link to="/login" className="afr-btn afr-btn--outline afr-btn--lg" data-testid="notfound-btn-login">
            Se connecter
          </Link>
        </div>
      </section>
      <PublicFooter />
    </div>
  );
}
